// Taxonomy version history list for the Audit Log tab.
// Mirrors the VersionList pattern from versioned-levels.

import { Card, CardContent } from '@/components/ui/card'
import { TableSkeleton } from '@/components/shared/LoadingSkeleton'
import { StatusBadge } from '@/components/features/versioned-levels/StatusBadge'
import { deriveVersionStatus, type VersionSummary } from '@/lib/api/frameworkConfig'

interface TaxonomyVersionListProps {
  versions: VersionSummary[]
  isLoading: boolean
}

export function TaxonomyVersionList({ versions, isLoading }: TaxonomyVersionListProps) {
  if (isLoading) {
    return <TableSkeleton />
  }

  if (versions.length === 0) {
    return (
      <Card>
        <CardContent className="py-8 text-center text-sm text-muted-foreground">
          No versions yet.
        </CardContent>
      </Card>
    )
  }

  return (
    <div className="space-y-2">
      {versions.map((v) => {
        const status = deriveVersionStatus(v)
        return (
          <Card key={v.id}>
            <CardContent className="flex items-center justify-between py-3">
              <div className="flex items-center gap-3">
                <span className="font-medium">Version {v.version_number}</span>
                <StatusBadge
                  status={status}
                  labels={{
                    active: 'Active',
                    draft: 'Draft',
                    retired: 'Retired',
                  }}
                />
              </div>
              <div className="flex items-center gap-4 text-sm text-muted-foreground">
                {v.created_at && (
                  <span>Created {new Date(v.created_at).toLocaleDateString()}</span>
                )}
                {v.activated_at && (
                  <span>Activated {new Date(v.activated_at).toLocaleDateString()}</span>
                )}
                {v.confirmed_at && (
                  <span>Confirmed {new Date(v.confirmed_at).toLocaleDateString()}</span>
                )}
              </div>
            </CardContent>
          </Card>
        )
      })}
    </div>
  )
}
